import { FC, useState } from 'react';

import { Registration } from '../../../../types/registrationTypes';
import CustomerForm from './containers/customerForm';
import useIsMounted from '../../../../hooks/useIsMounted';

interface Props {
  registration?: Registration | null;
  updateRegistration: (registration: Registration) => Promise<Registration>;
  preventSwitchTabDueToUnsavedData: (value: boolean) => void;
  defaultCountry: string;
  disabled: boolean;
}

const RegistrationCustomer: FC<Props> = ({ registration, updateRegistration, preventSwitchTabDueToUnsavedData, defaultCountry, disabled }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const isMounted = useIsMounted();

  const updateCustomer = async (customerData: Registration['customer']) => {
    if (!registration?.id) return;

    setLoading(true);
    try {
      await updateRegistration({
        ...registration,
        customer: customerData
      });
    } catch (error) {
      throw error;
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  };

  return (
    <CustomerForm
      customer={registration?.customer}
      defaultCountry={defaultCountry}
      updateCustomer={updateCustomer}
      loading={loading}
      preventSwitchTabDueToUnsavedData={preventSwitchTabDueToUnsavedData}
      disabled={disabled}
    />
  );
};

export default RegistrationCustomer;
